import { KeyValueItem, State } from "./types";
import { isBlank } from "utils/string";

export default function validateItem(state: State, item: KeyValueItem) {
  let keyError = null;
  let valueError = null;

  const { value } = item;

  if (isBlank(item.key)) {
    keyError = "isBlank";
  } else if (item.key[0] === " ") {
    keyError = "startsWithSpace";
  }

  if (isBlank(value)) {
    valueError = "isBlank";
  }

  if (keyError || valueError) {
    return { key: keyError, value: valueError };
  }

  return null;
}
